import axios from "axios";
import sha256 from "sha256";

const BASE_URL = "https://e-commerce-backend-murex.vercel.app/api/v1";

export const isLoggedInApi = async (query) => {
  query.password = sha256(query.password);

  try {
    const response = await axios.get(`${BASE_URL}/user`, { params: query });
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const createUserApi = async (user) => {
  user.password = sha256(user.password);
  try {
    const response = await axios.post(`${BASE_URL}/user`, user);
    console.log(response);
    return response;
  } catch (error) {
    console.log(error);
  }
};
